<template>
    <div>
        <!-- DIALOGO PARA ERRORES -->
        <div class="p-d-flex">
            <Toast />
        </div>

        <!-- DIALOGO CONFIRMAR ELIMINACION -->
        <Dialog :visible.sync="dialogDelete" :styles="{ width: '450px' }" header="Confirmar" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span>Estas seguro de eliminar <b>{{ objetoEditado.placa }}</b>.?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="dialogDelete = false" />
                <Button label="Si" icon="pi pi-check" class="p-button-text" @click="eliminar()" />
            </template>
        </Dialog>

        <!-- DIALOGO DE LOADING -->
        <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>

        <!-- NUEVO CONCEPTO -->
        <Dialog :visible.sync="dialogoNuevoRemolque" :closeOnEscape="true" :closable="false"
            :containerStyle="{ width: '500px' }">
            <Remolque @cierraVentana="dialogoNuevoRemolque = false"></Remolque>
        </Dialog>

        <Card>
            <template #title>
                <div id="pdfprueba" class="text-left p-d-flex justify-center p-fluid grid formgrid">
                    <div class="mt-0 ml-0 mr-0 mb-0 pt-0 pl-3 pr-0 pb-0 pa-0 justify-right field col-6 md:col-6">
                        Remolques
                    </div>
                    <div
                        class="mt-0 ml-0 mr-0 mb-0 pt-0 pl-0 pr-5 pb-0 pa-0 text-right justify-right field col-6 md:col-6">
                        <Button icon="pi pi-plus" @click="nuevoRemolque()" class="mr-3 p-button-rounded" />
                        <Button icon="pi pi-undo" @click="getRemolques()" class="p-button-rounded" />
                    </div>
                </div>
            </template>
            <template #content>
                <DataTable class="p-datatable-sm" :filters.sync="filtrosRemolques" removableSort showGridlines
                    ref="clientes" :value="itemsRemolques" responsiveLayout="scroll" :paginator="true" :rows="10"
                    :globalFilterFields="[
                        'id',
                        'placa',
                        'descripcion',
                    ]"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Remolques."
                    :loading="loadingItemsRemolques">
                    <template #header>
                        <div class="flex justify-content-between">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filtrosRemolques['global'].value" placeholder="Buscar" />
                            </span>
                        </div>
                    </template>
                    <Column sortable field="id" header="ID"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.id }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column sortable field="placa" header="Placa"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.placa }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column sortable field="subTipoRem.subTipoRem" header="Remolque"
                        :bodyStyle="{ 'text-align': 'left', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.subTipoRem.subTipoRem }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText type="text" v-model="filterModel.value" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column :exportable="false" :styles="{ 'min-width': '8rem' }" header="Editar/Eliminar">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                @click="editar(slotProps.data)" />
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                @click="confirmDeleteProduct(slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
            </template>
        </Card>
    </div>
</template>
<script>
import axios from "axios";
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import Remolque from "./Remolque.vue";
import html2pdf from "html2pdf.js";

export default {
    components: { Remolque },

    data() {
        return {
            loadingMensaje: "",
            loading: false,
            dialogoNuevoRemolque: false,

            filtrosRemolques: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'id': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH },], },
                'placa': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH },], },
                'subTipoRem.subTipoRem': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH },], },

            },
            loadingItemsRemolques: false,
            objetoEditado: {},

            dialogDelete: false,
            editedIndex: -1,

            base: ''
        };
    },
    computed: {
        empresa() {
            return this.$store.state.usuario;
        },
        itemsRemolques() {
            return this.$store.state.listRemolqueStore;
        },
    },
    created() {
        this.getRemolques()
    },
    methods: {
        nuevoRemolque() {
            this.dialogoNuevoRemolque = true;

            if (this.$store.state.remolqueStore != 0) {
                let obj = {
                    id: 0,
                    placa: '',
                    subTipoRem: {},
                    usuarioCreador: '',
                    usuarioModificador: '',
                }
                this.$store.state.remolqueStore = { ...obj }
            }
        },

        editar(data) {
            this.$store.state.remolqueStore = { ...data }
            this.dialogoNuevoRemolque = true
        },

        confirmDeleteProduct(data) {
            this.editedIndex = this.itemsRemolques.indexOf(data)
            this.objetoEditado = { ...data };
            this.dialogDelete = true;
        },

        async getRemolques() {
            this.loadingItemsRemolques = true;
            try {
                let response = await axios.get('CatalogosCartaPorte/GetRemolques/' + this.empresa.empresaBase)
                this.$store.state.listRemolqueStore = response.data
                console.log(response)
                this.loadingItemsRemolques = false;

            } catch (error) {
                console.log(error)
                this.loadingItemsRemolques = false;
            }
        },

        async eliminar() {
            this.loading = true;
            this.loadingMensaje = 'Procesando soliciud, espere...'

            try {
                this.objetoEditado.usuarioModificador = this.empresa.nombre

                let response = await axios.put('CatalogosCartaPorte/PutRemolquesEstatus/' + this.empresa.empresaBase, this.objetoEditado)
                this.itemsRemolques.splice(this.editedIndex, 1)

                this.dialogDelete = false;
                this.loading = false;

                this.$toast.add({ severity: 'success', detail: 'Remolque eliminado con éxito.', life: 3000 });

            } catch (error) {
                console.log(error)
                this.$toast.add({ severity: 'error', detail: 'Error al eliminar, intente nuevamente.', life: 3000 });
                this.loading = false;
            }
        },
    },
};
</script>
